module.exports = __webpack_public_path__ + "static/media/Sreemongol.6d0300f1.png";